<svelte:options accessors={true}/>
<script>
    import { onMount } from 'svelte';
    import ReportsService from "../../services/reports.service";
    import AuthService from '../../services/auth.service.js';
    import Loader from "../../components/Loader.svelte";
    import ExportService from '../../services/export.service';
    import {formatValue} from '../../helpers/format.helper';

    let page, loading = false, reportData, errorMessage;

    export let user, params, loadingExport = false;

    //Catch when a value change
    $: loadData(params);

    onMount(() => {
        loadData();
    });

    async function loadData() {
        if (loading) return;
        loading = true;
        reportData = null;
        const url = '/org/' + params.org + '/hr_staffing_dashboard/date/' + params.year
        let result = null;

        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) reportData = result.data;
        loading = false;

        setTimeout(() => {
            tablesLoaded(true);
            enableTableSelection();
        }, 1000);
    }

    export const exportToExcel = async () => {
        loadingExport = true;
        try {
            const url = '/org/' + params.org + '/hr_staffing_dashboard/date/' + params.year
            const fileName = `HR-Staffing-Dashboard-${jQuery('#dropdownOrganizations').text()}`;
            const staffingDashboardReport = (await ReportsService.load(url)).data;
            if (staffingDashboardReport) {            
                await ExportService.downloadStaffingDasboard(
                    staffingDashboardReport,
                    fileName,
                    params.year
                );
            } else {
                alert('Nothing to export');
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            loadingExport = false;
        }
    };

    const sectionKeys = {
        headcount_turnover: {
            annual_headcount: [
                { key: 'beginning_delta', title: 'Beginning Sales and Mktg Staff'},
                { key: 'terms_in_month', title: 'Terms in Month - Sales and Mktg Staff'},
                { key: 'hires_in_month', title: 'Hires in Month - Sales and Mktg Staff'},
                { key: 'headcount', title: 'Sales and Mktg Headct - End of Month'},
                { key: 'total', title: 'Total Budgeted Sales & Mktg Headcount'}
            ],
            turnover_by_type: [
                { key: 'regrettable', title: 'Regrettable - Voluntary'},
                { key: 'non-regrettable', title: 'Non-Regrettable - Voluntary'},
                { key: 'voluntary', title: 'Voluntary'},
                { key: 'involuntary', title: 'Involuntary'},
                { key: 'total', title: 'Total'}
            ],
            turnover_by_reason: [
                { key: 'comp_ben', title: 'Better Opportunity - Comp & Ben'},
                { key: 'job_duties', title: 'Better Opportunity - Job Duties/Workload'},
                { key: 'performance', title: 'Performance'},
                { key: 'personal', title: 'Personal / Other'},
                { key: 'rif', title: 'RIF'},
                { key: 'total', title: 'Total Terminations'}
            ]
        },
        candidate_conversion: [
            { key: 'referral', title: 'Referral'},
            { key: 'job_board', title: 'Job Board'},
            { key: 'agency', title: 'Agency'},
            { key: 'internal', title: 'Internal'},
            { key: 'total', title: 'Total'}
        ]
    }

</script>

{#if loading}
    <Loader></Loader>
{:else}
    <button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>
    <!-- Headcount and Turnover -->
    <div class="table-wrapper hr-report staffing-dashboard">
        <table class="table table-sm container-fluid selectable-table">
            <thead>
                <tr>
                   <th  class="col-header text-left staffing-dashboard-annual">Headcount and Turnover</th>
                   {#each reportData.headers.dates as date}
                        <th class="staffing-dashboard-annual" colspan="{date === 'total' ? 4 : 1}">{date}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="section-subtitle" colspan="14">Annual Sales & Marketing Headcount Budgeted vs Forecast & Hiring Cadence</td>
                </tr>
                {#each sectionKeys.headcount_turnover.annual_headcount as row}
                    <tr>
                        <td class="text-left readOnly {(row.key == 'total')?'staffing-dashboard-total-row':''}">
                            { row.title }
                        </td>
                        {#each reportData.headers.dates as date}
                            <td colspan="1" class="readOnly {(row.key == 'total')?'staffing-dashboard-total-row':''}">
                                {reportData.data.headcount_turnover.annual[row.key][date]}
                            </td>
                        {/each}
                    </tr>
                {/each}
                <tr><td colspan="14" class="staffing-dashboard-space"></td></tr>
                <tr>
                    <td class="section-subtitle" colspan="14">Turnover by Type</td>
                </tr>
                {#each sectionKeys.headcount_turnover.turnover_by_type as row}
                    <tr>
                        <td class="text-left readOnly {(row.key == 'total')?'staffing-dashboard-total-row':''}">
                            { row.title }
                        </td>
                        {#each reportData.headers.dates as date}
                            <td colspan="1" class="readOnly { ['total', 'voluntary'].includes(row.key) ?'staffing-dashboard-total-row':''}">
                                {reportData.data.headcount_turnover.turnover_by_type[row.key][date]}
                            </td>
                        {/each}
                    </tr>
                {/each}
                <tr><td colspan="14" class="staffing-dashboard-space"></td></tr>
                <tr>
                    <td class="section-subtitle" colspan="14">Turnover by Reason</td>
                </tr>
                {#each sectionKeys.headcount_turnover.turnover_by_reason as row}
                    <tr>
                        <td class="text-left readOnly {(row.key == 'total')?'staffing-dashboard-total-row':''}">
                            { row.title }
                        </td>
                        {#each reportData.headers.dates as date}
                            <td colspan="1" class="readOnly {(row.key == 'total')?'staffing-dashboard-total-row':''}">
                                {reportData.data.headcount_turnover.turnover_by_reason[row.key][date]}
                            </td>
                        {/each}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
    <!-- Candidates Conversion by Source -->
    <div class="table-wrapper hr-report staffing-dashboard">
        <table class="table table-sm container-fluid selectable-table">
            <thead>
                <tr>
                   <th class="col-header text-left staffing-dashboard-annual">Candidates Conversion by Source</th>
                   {#each reportData.headers.periods as period}
                        <th colspan="5" class="staffing-dashboard-annual border-x-light">{period}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="staffing-dashbord-header"></td>
                    {#each reportData.headers.periods as period, periodIndex}
                        {#each reportData.headers.candidates_conversion as header, headerIndex}
                            <td class="readOnly {[1,2].includes(periodIndex) && headerIndex === 0 ? 'border-l-dark' : ''}"><u>{header.title}</u></td>
                        {/each}
                    {/each}
                </tr>
                {#each sectionKeys.candidate_conversion as row}
                    <tr>
                        <td class="text-left readOnly {(row.key == 'total')?'staffing-dashboard-total-row':''}">
                            { row.title }
                        </td>
                        {#each reportData.headers.periods as period, periodIndex}
                            {#each reportData.headers.candidates_conversion as header, headerIndex}
                                <td colspan="1" 
                                    class="readOnly {(row.key == 'total')?'staffing-dashboard-total-row':''} {[1,2].includes(periodIndex) && headerIndex === 0 ? 'border-l-dark' : ''}">
                                    {reportData.data.candidates_conversion[row.key][period][header.key]}
                                </td>
                            {/each}
                        {/each}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}

<style>
    .section-subtitle {
        text-align: left;
        font-weight: bold;
        color: #000;
    }

    .border-x-light {
        border-right: solid #FFF 1px;
        border-left: solid #FFF 1px;
    }

    .border-l-dark {
        border-left: solid #000 1px;
    }
</style>